<mc-notification-bar></mc-notification-bar>

<mc-app-top-area (actionEmit)="handleTopMenuAction($event)"></mc-app-top-area>

<main class="Grid__main">
  @if (!isSplashScreen) {
    <nav mc-app-side-area-links class="Grid__side-links"></nav>
  }

  @if (loading) {
    <grid-ui-loading [size]="'large'"></grid-ui-loading>
  }
  <div class="Grid__content" [hidden]="loading">
    <router-outlet></router-outlet>
  </div>
</main>

<grid-ui-toast-container></grid-ui-toast-container>

@if (privacySettingsStorageService.showCookiesBannerChanges | async) {
  <mc-cookies-notification-banner (action)="handleCookiesNotificationBannerAction($event)"></mc-cookies-notification-banner>
}

@if (isPreviewMode) {
  <mc-preview-mode-watermark></mc-preview-mode-watermark>
}
